/**
 * D4F COLLECTION USPs - MOBILE SLIDER
 * - Auto-Rotation auf Mobile
 * - Touch/Swipe Support
 * - Pausiert bei Hover/Touch
 */
(function () {
  const section = document.querySelector('.d4f-collection-usps');
  if (!section) return;

  const track = section.querySelector('.d4f-collection-usps__track');
  const items = Array.from(section.querySelectorAll('.d4f-collection-usps__item'));

  if (!track || items.length === 0) return;

  // Settings
  const autoplayEnabled = section.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(section.dataset.autoplaySpeed) * 1000 || 4000;

  // State
  let currentIndex = 0;
  let autoplayInterval = null;
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  // Nur auf Mobile aktiv (< 768px)
  let isMobile = window.innerWidth < 768;

  /**
   * INITIALISIERUNG
   */
  function init() {
    if (!isMobile) return;

    updateSlider();

    if (autoplayEnabled) {
      startAutoplay();
    }

    // Event Listeners
    addEventListeners();
  }

  /**
   * SLIDER AKTUALISIEREN
   */
  function updateSlider() {
    if (!isMobile) return;

    const offset = currentIndex * -100;
    track.style.transform = `translateX(${offset}%)`;
  }

  /**
   * ZU SLIDE SPRINGEN
   */
  function goToSlide(index) {
    currentIndex = index;
    if (currentIndex < 0) currentIndex = items.length - 1;
    if (currentIndex >= items.length) currentIndex = 0;
    updateSlider();
  }

  /**
   * NÄCHSTER SLIDE
   */
  function nextSlide() {
    goToSlide(currentIndex + 1);
  }

  /**
   * VORHERIGER SLIDE
   */
  function prevSlide() {
    goToSlide(currentIndex - 1);
  }

  /**
   * AUTOPLAY STARTEN
   */
  function startAutoplay() {
    if (!autoplayEnabled || !isMobile) return;
    stopAutoplay(); // Cleanup
    autoplayInterval = setInterval(nextSlide, autoplaySpeed);
  }

  /**
   * AUTOPLAY STOPPEN
   */
  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  /**
   * TOUCH EVENTS
   */
  function handleTouchStart(e) {
    if (!isMobile) return;
    isDragging = true;
    startPos = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    track.classList.add('is-dragging');
    stopAutoplay();
  }

  function handleTouchMove(e) {
    if (!isDragging || !isMobile) return;

    const currentPosition = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    const diff = currentPosition - startPos;
    currentTranslate = prevTranslate + diff;

    // Visual feedback während Drag
    track.style.transform = `translateX(calc(${currentIndex * -100}% + ${diff}px))`;
  }

  function handleTouchEnd(e) {
    if (!isDragging || !isMobile) return;

    isDragging = false;
    track.classList.remove('is-dragging');

    const movedBy = currentTranslate - prevTranslate;

    // Swipe threshold (50px)
    if (movedBy < -50 && currentIndex < items.length - 1) {
      nextSlide();
    } else if (movedBy > 50 && currentIndex > 0) {
      prevSlide();
    } else {
      updateSlider();
    }

    prevTranslate = currentIndex * -100;

    // Autoplay wieder starten
    if (autoplayEnabled) {
      startAutoplay();
    }
  }

  /**
   * EVENT LISTENERS
   */
  function addEventListeners() {
    if (!isMobile) return;

    // Touch Events
    track.addEventListener('touchstart', handleTouchStart, { passive: true });
    track.addEventListener('touchmove', handleTouchMove, { passive: true });
    track.addEventListener('touchend', handleTouchEnd);

    // Mouse Events (für Desktop-Testing)
    track.addEventListener('mousedown', handleTouchStart);
    track.addEventListener('mousemove', handleTouchMove);
    track.addEventListener('mouseup', handleTouchEnd);
    track.addEventListener('mouseleave', () => {
      if (isDragging) handleTouchEnd();
    });

    // Pause on Hover (nur wenn Autoplay aktiv)
    if (autoplayEnabled) {
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
    }
  }

  /**
   * RESIZE HANDLER
   */
  function handleResize() {
    const wasMobile = isMobile;
    isMobile = window.innerWidth < 768;

    // Von Desktop zu Mobile gewechselt
    if (!wasMobile && isMobile) {
      init();
    }

    // Von Mobile zu Desktop gewechselt
    if (wasMobile && !isMobile) {
      stopAutoplay();
      track.style.transform = '';
    }
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 250);
  });

  // Initial Setup
  init();

  console.log('[D4F USPs] Mobile Slider initialized:', {
    items: items.length,
    autoplay: autoplayEnabled,
    speed: autoplaySpeed / 1000 + 's',
    isMobile: isMobile
  });
})();